define('app/sds/additionaldata/list/sds-additionaldata-list',["service!selcomm", "$q"], function (SelcommWS, $q) {
	function safeFunction(fn, ifNot) {
		return angular.isFunction(fn) ? fn : (arguments.length > 1 ? ifNot : angular.noop);
	}
	return {
		require: {},
		controller: {
			properties: {
				source: function () { return this._source || {}; },
				_canAdd: function () { return safeFunction(this.source.canAdd); },
				_canUpdate: function () { return safeFunction(this.source.canUpdate); },
				_canDelete: function () { return safeFunction(this.source.canDelete); },

				attributes: function () { return this.source.attributes || this.source; },

				addableAttributes: function () { }
			},
			prototype: {
				add: function() {
					return safeFunction(this.source.add).apply(this.source, arguments)
				},
				update: function () {
					return safeFunction(this.source.update).apply(this.source, arguments)
				},
				delete: function () {
					return safeFunction(this.source.delete).apply(this.source, arguments)
				},
				canAdd: function (adding) {
					return this.add || this.source.canAdd(adding);
				},
				canUpdate: function (updating) {
					return this.update || this.source.canUpdate(updating);
				},
				canDelete: function (deleting) {
					return this.deleting || this.source.canDelete(deleting);
				},
				loadAdditionalFieldDataList: function loadAdditionalFieldDataList() {
					return SelcommWS.get("Contact", "ContactAdditionalFieldDataList", {
						ContactCode: SelcommWS.authentication.currentSession.CurrentContactCode
					});
				}

			},
			constructor: ["$attrs", "$self", function ($attrs, vm) {
				var isDefined = {
					add: "add" in $attrs,
					delete: "delete" in $attrs,
					update: "update" in $attrs
				};

				angular.extend(this, {
					canAdd: function (locals) {
						return isDefined.add && this._canAdd(locals);
					},
					canUpdate: function (locals) {
						return isDefined.update && this._canUpdate(locals);
					},
					canDelete: function (locals) {
						return isDefined.canDelete && this._canDelete(locals);
					}
				});
				vm.loading = $q.all(vm.loadAdditionalFieldDataList().then(function (additionalDataList) {
					vm.additionalFieldDataList = additionalDataList
				}));
			}]
		}
	};
});
